import { render, staticRenderFns } from "./IconDatabase.vue?vue&type=template&id=6fdab6ef"
import script from "./IconDatabase.vue?vue&type=script&lang=js"
export * from "./IconDatabase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports